import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {
  MarketingNotificationFilters,
  PreviewMarketingNotificationJobResponse,
  PreviewMarketingNotificationJobResultResponse,
  SendMarketingNotificationResponse
} from "admin-api-dto";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private readonly http: HttpClient) {}

  manualCheckForNotifications(currentTime?: string, mode: 'full' | 'hourly' = 'full') {
    return this.http.post<{ status: string }>(`${environment.apiUrl}/api/private/notifications/check`, {
      currentTime,
      mode
    });
  }

  resendNotification(userId: string, notificationId: string) {
    return this.http.post<{ status: string }>(`${environment.apiUrl}/api/private/notifications/resend`, {
      userId,
      notificationId,
    });
  }

  triggerCommandForUsers(type: 'full-new-eligible-lotteries', lotteryId: string) {
    return this.http.post<{ status: string; count: number }>(`${environment.apiUrl}/api/private/notifications/command-for-users`, {
      type,
      lotteryId,
    });
  }

  startMarketingNotificationPreview(filters: MarketingNotificationFilters) {
    return this.http.post<PreviewMarketingNotificationJobResponse>(`${environment.apiUrl}/api/private/notifications/marketing-notification/preview`, {filters});
  }

  getMarketingNotificationPreviewResult(jobId: string) {
    return this.http.get<PreviewMarketingNotificationJobResultResponse>(`${environment.apiUrl}/api/private/notifications/marketing-notification/preview/${jobId}`);
  }

  sendMarketingNotification(userIds: string[], params: { textMessage: string | undefined; emailTemplateId: string | undefined; pushText: string | undefined; category: string | undefined }) {
    return this.http.post<SendMarketingNotificationResponse>(`${environment.apiUrl}/api/private/notifications/marketing-notification/send`, {
      userIds,
      ...params,
    });
  }
}
